<template>
  <div
    ref="tableContainerRef"
    class="advanced-table-container"
    :class="{
      'advanced-table-container--auto-height': props.autoHeight,
      'advanced-table-container--summary-scrollbar-below': props.summaryScrollbarBelow && summaryTableHeight > 0,
      'advanced-table-container--sort-button-cycle': props.sortButtonCycle,
    }"
    :style="{ '--advanced-table-summary-height': `${summaryTableHeight}px` }"
  >
    <div
      ref="tableTitleRef"
      class="flex justify-between table_title"
    >
      <div class="fill_tabs">
        <slot name="tabs" />
      </div>
      <div class="Issearch">
        <slot name="search" />
      </div>
      <div
        v-show="isShow"
        :style="{ width: props.isFilter ? '100%' : 'auto' }"
        class="flex justify-between"
      >
        <div />
        <div
          ref="pageCenterHeigth"
          class="flex items-center"
        >
          <el-popover
            class="popover_L"
            placement="bottom-end"
            popper-class="advanced-table-popover"
            trigger="click"
          >
            <template #reference>
              <!-- 选择 -->
              <el-button
                class="caobtn"
                plain
              >
                <svg
                  t="1764059595961"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="17810"
                  width="16"
                  height="16"
                >
                  <path
                    d="M85.312 768H384v85.312H85.312V768z m0-298.688h384v85.376h-384V469.312z m0-298.624h853.376V256H85.376V170.688z m796.8 385.024l49.28-16.64 42.688 73.856-39.04 34.368c4.864 23.296 4.864 47.36 0 70.72l39.04 34.368-42.688 73.92-49.28-16.704a170.112 170.112 0 0 1-61.248 35.392l-10.24 51.008h-85.248l-10.24-51.008a170.496 170.496 0 0 1-61.248-35.456l-49.28 16.768-42.688-73.92 39.04-34.368a171.392 171.392 0 0 1 0-70.72l-39.04-34.368 42.688-73.856 49.28 16.64c17.536-15.744 38.4-27.904 61.248-35.392l10.24-51.008h85.312l10.24 51.072c22.848 7.424 43.648 19.584 61.184 35.392zM768 768a85.312 85.312 0 1 0 0-170.688A85.312 85.312 0 0 0 768 768z"
                    p-id="17811"
                  />
                </svg>
              </el-button>
            </template>
            <div
              class="wrapper"
              @click="wrapperFn"
            >
              <div class="serch">
                <el-input
                  v-model="search"
                  placeholder="请输入内容"
                  @input="searchFn"
                />
              </div>
              <div class="center">
                <div class="cen_l">
                  <div class="titBox">
                    <div class="tit">
                      {{ proxy.$t('Filter.DisplayList') }}
                    </div>
                    <div
                      class="dongjieBtn"
                      @click.stop="handleClickOutside"
                    >
                      <el-popover
                        v-model="dongjieBtnShow"
                        :teleported="false"
                        popper-class="depopover"
                        placement="bottom"
                        trigger="click"
                      >
                        <div class="freezeBox">
                          <div>
                            {{ proxy.$t('Filter.frontToBack') }}
                            <el-select
                              v-model="freezeNumL"
                              :teleported="false"
                              style="width: 125px"
                              placeholder="请选择"
                              @change="update($event, 1)"
                            >
                              <el-option
                                v-for="item in freezeL"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              />
                            </el-select>
                          </div>
                          <div style="margin-top: 10px">
                            {{ proxy.$t('Filter.backToFront') }}
                            <el-select
                              v-model="freezeNumR"
                              :teleported="false"
                              style="width: 125px"
                              placeholder="请选择"
                              @change="update($event, 2)"
                            >
                              <el-option
                                v-for="item in freezeR"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              />
                            </el-select>
                          </div>
                        </div>
                        <template #reference>
                          <el-button
                            :class="dongjieBtnShow ? 'Btnshow' : ''"
                            type="text"
                          >
                            <svg
                              t="1764058195858"
                              class="icon"
                              viewBox="0 0 1024 1024"
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                              p-id="11660"
                              width="16"
                              height="16"
                            >
                              <path
                                d="M804.382118 180.705882H242.206118A61.500235 61.500235 0 0 0 180.705882 242.206118v562.176c0 33.972706 27.527529 61.500235 61.500236 61.500235h562.176a61.500235 61.500235 0 0 0 61.500235-61.500235V242.206118A61.500235 61.500235 0 0 0 804.382118 180.705882zM242.206118 233.411765h562.176c4.848941 0 8.794353 3.915294 8.794353 8.794353v562.176c0 4.848941-3.915294 8.794353-8.794353 8.794353H242.206118a8.794353 8.794353 0 0 1-8.794353-8.794353V242.206118c0-4.848941 3.915294-8.794353 8.794353-8.794353z"
                                fill="#000000"
                                p-id="11661"
                              />
                              <path
                                d="M367.405176 187.361882a26.352941 26.352941 0 0 1 37.526589 36.833883l-2.499765 2.56-177.874824 158.117647a26.352941 26.352941 0 0 1-37.526588-36.833883l2.529883-2.56 177.844705-158.117647zM417.581176 293.104941a26.352941 26.352941 0 0 1 38.219295 36.141177l-2.469647 2.590117-228.382118 210.82353a26.352941 26.352941 0 0 1-38.249412-36.141177l2.499765-2.590117 228.382117-210.82353zM417.581176 451.222588a26.352941 26.352941 0 0 1 38.219295 36.141177l-2.469647 2.590117-228.382118 210.82353a26.352941 26.352941 0 0 1-38.249412-36.141177l2.499765-2.590117 228.382117-210.82353zM417.581176 609.340235a26.352941 26.352941 0 0 1 38.219295 36.141177l-2.469647 2.590117-228.382118 210.82353a26.352941 26.352941 0 0 1-38.249412-36.141177l2.499765-2.590117 228.382117-210.82353z"
                                fill="#000000"
                                p-id="11662"
                              />
                              <path
                                d="M435.440941 180.705882c13.432471 0 24.545882 10.059294 26.172235 23.04l0.180706 3.312942v632.470588a26.352941 26.352941 0 0 1-52.495058 3.312941l-0.210824-3.312941v-632.470588c0-14.546824 11.806118-26.352941 26.352941-26.352942z"
                                fill="#000000"
                                p-id="11663"
                              />
                            </svg>
                            {{ proxy.$t('Filter.Freeze') }}
                          </el-button>
                        </template>
                      </el-popover>
                      <!-- 冻结 -->
                    </div>
                  </div>
                  <div class="list">
                    <tableHearList
                      v-model:list="allColumns"
                      :search="search"
                      @update="update"
                    />
                  </div>
                </div>
                <div class="cen_r">
                  <div class="titBox tit_r">
                    <div class="tit">
                      {{ proxy.$t('Filter.HideList') }}
                    </div>
                    <div class="fixed" />
                  </div>
                  <div class="list">
                    <tableHearList
                      v-model:list="allColumns"
                      :search="search"
                      :type="2"
                      @update="update"
                    />
                  </div>
                </div>
              </div>
            </div>
          </el-popover>
          <slot name="button" />
        </div>
      </div>
    </div>
    <slot name="center" />
    <actionWidth @on-width="onWidthFn">
      <template #actionWidth>
        <slot name="action" />
      </template>
    </actionWidth>
    <!-- 表格 -->
    <!-- 批量操作-->

    <div
      class="pageCenterHeigth"
      :style="{ paddingBottom: props.autoHeight || props.maxHeight !== undefined ? '0px' : cHeight - 21 + 'px' }"
    >
      <div
        v-if="selectAll?.length > 0"
        class="selection_box flex"
      >
        <div class="title">
          {{ proxy.$t('Shared.Select') }} {{ selectAll.length }} {{ proxy.$t('Unit.data') }}
        </div>
        <div class="btn">
          <slot name="selectBtn" />
          <span class="elescBtnT">|</span>

          <el-button
            type="primary"
            link
            @click="CancelSelect"
          >
            {{ proxy.$t('Shared.CancelSelect') }}
          </el-button>
        </div>
      </div>
      <el-table
        ref="tableRef"
        :key="tableKey"
        v-loading="loading"
        :height="props.autoHeight || props.maxHeight !== undefined ? undefined : appMainHei - cHeight"
        :max-height="props.maxHeight"
        :fit="props.fillLastColumn"
        scrollbar-always-on
        :show-summary="showSummary"
        :summary-method="props.summaryMethod"
        :data="props.data"
        :default-sort="props.defaultSort"
        border
        size="small"
        :row-key="props.rowKey"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        :header-row-style="{ position: 'relative', background: '#ffffff' }"
        @scroll="scrollFn"
        @selection-change="handleSelectionChange"
        @header-dragend="handleHeaderDragend"
        @sort-change="handleSortChange"
        @expand-change="handleExpandChange"
      >
        <el-table-column
          v-if="selection"
          type="selection"
          width="55"
          align="center"
          :reserve-selection="!single"
          :selectable="props.selectable"
        />
        <el-table-column
          v-if="expand"
          type="expand"
          width="46"
          align="center"
          fixed="left"
        >
          <template #header>
            <slot name="expandHeader" />
          </template>
          <template #default="scope">
            <slot
              name="expand"
              :row="scope.row"
              :index="scope.$index"
            />
          </template>
        </el-table-column>
        <el-table-column
          v-for="(column, index) in visibleColumns"
          :key="column.prop || index"
          :prop="column.prop"
          :resizable="!column.resizable"
          :label-class-name="!column.resizable ? 'advanced-table-header--resizable' : ''"
          :label="column.label"
          :sortable="column.sortable"
          :sort-orders="props.sortButtonCycle ? ['ascending', 'descending'] : undefined"
          :width="displayColumnWidths[index]"
          :fixed="column.fixed"
          :min-width="MIN_COLUMN_WIDTH"
          :formatter="column.formatter"
          :align="column.align"
          :show-overflow-tooltip="column.showOverflowTooltip ?? !column.slot"
        >
          <template #header>
            <span>{{ column.label }}</span>
            <el-tooltip
              v-if="column.tooltip"
              :content="column.tooltip"
              :popper-style="{ maxWidth: '280px' }"
              placement="top"
              effect="dark"
            >
              <el-icon
                class="advanced-table-header__info"
                tabindex="0"
                role="img"
                :aria-label="`${column.label}：${column.tooltip}`"
                @click.stop
              >
                <InfoFilled />
              </el-icon>
            </el-tooltip>
          </template>
          <template #default="scope">
            <!-- 操作功能：操作列支持收起低频操作 -->
            <div v-if="column.slot && column.prop == 'action' && column.resizable">
              <slot
                name="action"
                :row="scope.row"
                :index="scope.$index"
              />
              <el-popover
                placement="bottom"
                popper-class="auto-popover"
              >
                <template #default>
                  <slot
                    name="actionResizable"
                    :row="scope.row"
                    :index="scope.$index"
                  />
                </template>
                <template #reference>
                  <el-icon class="actionResizable_icon">
                    <MoreFilled />
                  </el-icon>
                </template>
              </el-popover>
            </div>
            <!-- 自定义列插槽 -->
            <slot
              v-else-if="column.slot"
              :name="column.prop"
              :row="scope.row"
              :index="scope.$index"
            />
            <div
              v-else
              class="advanced-table-cell-text"
            >
              {{ formatEmptyValue(getNestedValue(scope.row, column.prop)) }}
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div
        v-show="total > 0"
        ref="pagination"
        class="pagination"
      >
        <div class="text-sm text-gray-600" />
        <el-pagination
          :current-page="props.currentPage"
          :page-sizes="props.pageSizeList"
          :page-size="props.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="props.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { InfoFilled } from '@element-plus/icons-vue';
import { computed, getCurrentInstance, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useAppStore } from '../../store/modules/app.ts';
import eventBus from '../../utils/eventBus.ts';

const { proxy } = getCurrentInstance();
// import tableHearList from './tableHearList.vue';
// name: 'AdvancedTable',
// components: { tableHearList, horizontalScrollbar },
const emits = defineEmits(['onpages', 'update:selectData', 'selectDataFn', 'expand-change', 'sort-change']);

const getNestedValue = (obj, path) => {
  if (!obj || !path) return undefined;
  if (!path.includes('.')) {
    return obj[path];
  }
  return path.split('.').reduce((current, key) => {
    return current ? current[key] : undefined;
  }, obj);
};

const formatEmptyValue = (value) => (value === null || value === undefined || value === '' ? '_' : value);

const props = defineProps({
  // 卡片内的小型列表按内容展开，其余页面保留原视口高度计算。
  autoHeight: {
    type: Boolean,
    default: false,
  },
  rowKey: {
    // 数据标识
    type: String,
    default: 'id',
  },
  isFilter: {
    type: Boolean,
    default: false,
  },
  isShow: {
    type: Boolean,
    default: true,
  },

  showSummary: {
    type: Boolean,
    default: false,
  },
  summaryScrollbarBelow: {
    type: Boolean,
    default: false,
  },
  summaryMethod: {
    type: Function,
    default: undefined,
  },
  defaultSort: {
    type: Object,
    default: undefined,
  },
  sortButtonCycle: {
    type: Boolean,
    default: false,
  },
  minWidth: {
    type: Number,
    default: 120,
  },
  fillLastColumn: {
    type: Boolean,
    default: true,
  },
  columnFillMode: {
    type: String,
    default: 'last',
    validator: (value: string) => ['last', 'equal'].includes(value),
  },
  loading: {
    // 是否加载框
    type: Boolean,
    default: false,
  },
  selection: {
    // 是否复选框
    type: Boolean,
    default: false,
  },
  selectable: {
    // 自定义行是否可选，用于禁用不允许重复选择的数据。
    type: Function,
    default: () => true,
  },
  expand: {
    type: Boolean,
    default: false,
  },
  expandAll: {
    type: Boolean,
    default: false,
  },
  expandRowKeys: {
    type: Array,
    default: () => [],
  },
  single: {
    // 是否单选
    type: Boolean,
    default: false,
  },
  isKey: {
    // 缓存唯一标识
    type: String,
    default: '',
  },
  pageSizeList: {
    type: Array,
    default: () => [10, 20, 30, 50],
  },
  // 导出导入操作
  exportList: { type: Array, default: () => [] },
  //     // 表格数据
  data: {
    type: Array,
    default: () => [],
  },
  // 总记录数
  total: {
    type: Number,
    default: 0,
  },
  columns: {
    type: Array,
    required: true,
    //      prop: 'name',   字段
    //     label: '方法1',
    //     sortable: true, // 排序
    //     width: 140, // 宽度
    //     fixed: false,  // 冻结
    //     slot: true,   // 排序
    //     hiddenByDefault: true // 隐藏
    // formatter: row => row.startTime + '~' + row.endTime
  },
  // 是否显示序号列
  showIndexColumn: {
    type: Boolean,
    default: true,
  },
  maxHeight: {
    // 弹窗等嵌入场景使用内容最大高度，不参与页面高度计算。
    type: [Number, String],
    default: undefined,
  },
  // 控制表格高度
  clientHeight: {
    // 父组件通过ref
    type: Number,
    default: 20,
  },
  // 表头置顶位置
  topHeight: {
    // 父组件通过ref
    type: Number,
    default: 150,
  },
  // 分页数据
  currentPage: {
    type: Number,
    default: 1,
  },
  // 表头置顶位置
  pageSize: {
    type: Number,
    default: 10,
  },
  selectData: {
    type: Array,
    default: () => [],
  },
});

const selectAll = ref([]);
const dataKeyIdArr = ref([]);
const dataStatus = ref(true);
const aWidth = ref(0);
const freezeNumR = ref(0);
const freezeNumL = ref(0);
const search = ref('');
const tableKey = ref(0);
const freezeL = ref([
  { label: proxy.$t('Filter.notFreeze'), value: 0 },
  { label: proxy.$t('Filter.Beforefreezing') + 1 + proxy.$t('Filter.Column'), value: 1 },
  { label: proxy.$t('Filter.Beforefreezing') + 2 + proxy.$t('Filter.Column'), value: 2 },
  { label: proxy.$t('Filter.Beforefreezing') + 3 + proxy.$t('Filter.Column'), value: 3 },
  { label: proxy.$t('Filter.Beforefreezing') + 4 + proxy.$t('Filter.Column'), value: 4 },
  { label: proxy.$t('Filter.Beforefreezing') + 5 + proxy.$t('Filter.Column'), value: 5 },
]);
const freezeR = ref([
  { label: proxy.$t('Filter.notFreeze'), value: 0 },
  { label: proxy.$t('Filter.Afterfreezing') + 1 + proxy.$t('Filter.Column'), value: 1 },
  { label: proxy.$t('Filter.Afterfreezing') + 2 + proxy.$t('Filter.Column'), value: 2 },
  { label: proxy.$t('Filter.Afterfreezing') + 3 + proxy.$t('Filter.Column'), value: 3 },
  { label: proxy.$t('Filter.Afterfreezing') + 4 + proxy.$t('Filter.Column'), value: 4 },
  { label: proxy.$t('Filter.Afterfreezing') + 5 + proxy.$t('Filter.Column'), value: 5 },
]);
const dongjieBtnShow = ref(false);
const allColumns = ref([]);
const visibleColumns = ref([]);
const tableContainerRef = ref<HTMLElement | null>(null);
const tableContainerWidth = ref(0);
const tableAvailableWidth = ref(0);
let tableWidthResizeObserver: ResizeObserver | null = null;

const MIN_COLUMN_WIDTH = 120;

function getColumnBaseWidth(column) {
  // 业务配置控制初始宽度；初始化与缓存恢复统一遵守 120px 下限。
  return Math.max(MIN_COLUMN_WIDTH, Number.parseFloat(column.width) || Number.parseFloat(column.minWidth) || props.minWidth);
}

// 始终由最后一个可见业务列补满，拖拽其他列不转移补满职责。
const fillColumn = computed(() => visibleColumns.value[visibleColumns.value.length - 1]);
const rawColumnMap = computed(() => new Map(props.columns.map((column: any) => [column.prop, column])));

const displayColumnWidths = computed(() => {
  const equalFill = props.columnFillMode === 'equal';
  // 未声明固定 width、仅声明 minWidth 的弹性列优先均分剩余宽度，避免固定操作列被单独拉宽。
  const flexibleIndices =
    props.fillLastColumn && !equalFill
      ? visibleColumns.value.reduce<number[]>((indices, column, index) => {
          const raw = rawColumnMap.value.get(column.prop);
          if (raw && raw.width === undefined && raw.minWidth !== undefined) indices.push(index);
          return indices;
        }, [])
      : [];
  const multiFill = equalFill || flexibleIndices.length > 0;
  const widths = visibleColumns.value.map((column) => (multiFill ? Math.ceil(getColumnBaseWidth(column)) : getColumnBaseWidth(column)));
  const extraWidth = Math.max(
    0,
    (multiFill ? tableAvailableWidth.value : tableContainerWidth.value) -
      (props.selection ? 55 : 0) -
      (props.expand ? 46 : 0) -
      widths.reduce((sum, width) => sum + width, 0),
  );
  if (props.fillLastColumn && equalFill && widths.length) {
    const available = Math.floor(extraWidth);
    const perColumn = Math.floor(available / widths.length);
    const remainder = available % widths.length;
    return widths.map((width, index) => width + perColumn + (index < remainder ? 1 : 0));
  }
  if (props.fillLastColumn && flexibleIndices.length) {
    const available = Math.floor(extraWidth);
    const perColumn = Math.floor(available / flexibleIndices.length);
    const remainder = available % flexibleIndices.length;
    flexibleIndices.forEach((columnIndex, order) => {
      widths[columnIndex] += perColumn + (order < remainder ? 1 : 0);
    });
    return widths;
  }
  const fillIndex = visibleColumns.value.indexOf(fillColumn.value);
  if (props.fillLastColumn && fillIndex !== -1) widths[fillIndex] += extraWidth;
  return widths;
});

function initTableWidthResize() {
  tableWidthResizeObserver?.disconnect();
  if (!tableContainerRef.value) return;
  const measureWidth = () => {
    const container = tableContainerRef.value;
    tableContainerWidth.value = container?.clientWidth || 0;
    const tableElement = tableRef.value?.$el;
    const containerStyle = container ? getComputedStyle(container) : null;
    const contentWidth = container
      ? container.clientWidth - (Number.parseFloat(containerStyle.paddingLeft) || 0) - (Number.parseFloat(containerStyle.paddingRight) || 0)
      : 0;
    // 容器 clientWidth 包含 padding；均分以真实表格宽度为准并预留像素边界。
    tableAvailableWidth.value = Math.max(0, Math.floor(tableElement?.clientWidth || contentWidth) - 1);
  };
  measureWidth();
  tableWidthResizeObserver = new ResizeObserver(measureWidth);
  tableWidthResizeObserver.observe(tableContainerRef.value);
  if (tableRef.value?.$el) tableWidthResizeObserver.observe(tableRef.value.$el);
}

watch(displayColumnWidths, () => {
  nextTick(() => tableRef.value?.doLayout?.());
});

const accompLish = ref([]);
const searchExtraHeight = ref(0);
const appMainHei = computed(() => useAppStore().appMainHei - props.topHeight - searchExtraHeight.value);

const pageCenterHeigth = ref(null);
const tableTitleRef = ref(null);
const tableTitleBaseHeight = ref(0);
let tableTitleResizeObserver = null;
const scrollContainer = ref(null);
const cHeight = ref(0);

const tableRef = ref(null);
watch(tableRef, () => nextTick(initTableWidthResize), { flush: 'post' });
const summaryTableHeight = ref(0);
let summaryResizeObserver: ResizeObserver | null = null;
watch(
  () => [tableRef.value, props.showSummary, props.summaryScrollbarBelow],
  (_value, _previous, onCleanup) => {
    let cancelled = false;
    summaryResizeObserver?.disconnect();
    summaryResizeObserver = null;
    summaryTableHeight.value = 0;
    onCleanup(() => {
      cancelled = true;
      summaryResizeObserver?.disconnect();
      summaryResizeObserver = null;
    });
    nextTick(() => {
      if (cancelled || !props.showSummary || !props.summaryScrollbarBelow) return;
      const footer = tableRef.value?.$el?.querySelector('.el-table__footer-wrapper');
      const footerTable = footer?.querySelector('table');
      if (!footer || !footerTable) return;
      const measureSummary = () => {
        // 只测量表格本身，排除横条槽位，避免 padding 与观察结果相互累加。
        summaryTableHeight.value = footer.offsetHeight > 0 ? footerTable.getBoundingClientRect().height : 0;
      };
      measureSummary();
      if (typeof ResizeObserver !== 'undefined') {
        summaryResizeObserver = new ResizeObserver(measureSummary);
        summaryResizeObserver.observe(footerTable);
      }
    });
  },
  { immediate: true, flush: 'post' },
);
watch(summaryTableHeight, () => {
  nextTick(() => tableRef.value?.doLayout?.());
});
let syncingSort = false;
watch(
  () => props.defaultSort,
  async (sort) => {
    await nextTick();
    if (!tableRef.value) return;
    // 父页面恢复默认排序时只同步箭头，不再次触发服务端查询。
    syncingSort = true;
    try {
      if (sort?.prop && sort.order) {
        tableRef.value.sort(sort.prop, sort.order);
      } else {
        tableRef.value.clearSort();
      }
    } finally {
      syncingSort = false;
    }
  },
);
const advancedTableContainer = ref(null);
const scrollFn = (e) => {
  advancedTableContainer.value?.style.setProperty('--table-scroll-left', `${e.scrollLeft || 0}px`);
  if (cHeight.value > 10) {
    eventBus.emit('table-scroll', e.scrollTop);
  }
};
// 将原生滚动容器事件转换为表格滚动参数。
const handleScroll = (event) => {
  const target = event.target;
  scrollFn({ scrollLeft: target.scrollLeft, scrollTop: target.scrollTop });
};
watch(
  () => selectAll.value,
  (val) => {
    console.log('selectAll.value--------', val);
    emits('selectDataFn', val);

    // emits('update:selectData', val);
  },
  { deep: true },
);
watch(
  () => props.data,
  () => {
    dataStatus.value = false;
    if (selectAll.value.length > 0 && props.data.length > 0) {
      nextTick(() => {
        const selectIds = selectAll.value?.map((v) => v[`${props.rowKey}`]) || [];
        console.log('1111111', selectIds);

        props.data.forEach((row) => {
          if (selectIds.includes(row[`${props.rowKey}`])) {
            tableRef.value?.toggleRowSelection(row, true);
          }
        });
      });
    }
    setTimeout(() => {
      dataStatus.value = true;
    }, 300);
  },
  { deep: true },
);
const applyExpandAll = async () => {
  if (!props.expand) return;
  await nextTick();
  setTimeout(() => {
    props.data.forEach((row) => {
      tableRef.value?.toggleRowExpansion(row, props.expandAll);
    });
  }, 0);
};
watch(() => [props.expandAll, props.data], applyExpandAll, { deep: true });
onMounted(() => {
  setTimeout(() => {
    tableBodyWrapper();
    cHeight.value = props.clientHeight;
    initTableTitleResize();
  }, 300);

  eventBus.on('parent-scroll', handleParentScroll);

  initTableWidthResize();
  initColumns();
});

onBeforeUnmount(() => {
  tableWidthResizeObserver?.disconnect();
  tableTitleResizeObserver?.disconnect();
  summaryResizeObserver?.disconnect();
  eventBus.off?.('parent-scroll', handleParentScroll);
});
const checkInfo = (data) => {
  selectAll.value = data;
  console.log(' selectAll.value ', selectAll.value);

  setTimeout(() => {
    nextTick(() => {
      const selectIds = selectAll.value?.map((v) => v[`${props.rowKey}`]) || [];
      props.data.forEach((row) => {
        if (selectIds.includes(row[`${props.rowKey}`])) {
          tableRef.value?.toggleRowSelection(row, true);
        }
      });
    });
  }, 200);
};
const toggleRowExpansion = (row, expanded) => {
  tableRef.value?.toggleRowExpansion(row, expanded);
};
// 替换选择而非追加回显，支持筛选、移除和关闭时同步清理。
const setSelection = async (rows) => {
  isUpdatingSelection = true;
  try {
    await nextTick();
    tableRef.value?.clearSelection();
    const rowMap = new Map(props.data.map((row) => [row[props.rowKey], row]));
    selectAll.value = uniqueByRowKey(rows).map((row) => rowMap.get(row[props.rowKey])).filter(Boolean);
    selectAll.value.forEach((row) => tableRef.value?.toggleRowSelection(row, true));
  } finally {
    isUpdatingSelection = false;
  }
};
defineExpose({ checkInfo, toggleRowExpansion, setSelection });
// 按钮宽度
const onWidthFn = (val) => {
  aWidth.value = val + 75;
  setActionWidth();
};
// 重置操作的宽度
const setActionWidth = () => {
  allColumns.value.forEach((v) => {
    if (v.prop == 'action' && v.resizable) {
      v.width = aWidth.value;
    }
  });
  if (visibleColumns.value.length > 0) {
    visibleColumns.value = allColumns.value.filter((column) => !column.hiddenByDefault);
    tableKey.value++;
    delAccompLish();
    refreshTable();
    nextTick(() => {
      tableBodyWrapper();
    });
  }
};

// 表格滚动容器处理函数
function tableScrollContainerFn() {
  nextTick(() => {
    // 通过ref获取表格容器（需在模板中给表格绑定ref="tableRef"）
    const tableScrollContainer = tableRef.value?.bodyWrapper;

    if (tableScrollContainer) {
      // 添加滚动事件监听
      tableScrollContainer.addEventListener('scroll', handleScroll);
    }
  });
}

// 获取表格的滚动容器
function tableBodyWrapper() {
  scrollContainer.value = null;
  nextTick(() => {
    scrollContainer.value = tableRef.value?.$el?.querySelector('.el-table__body-wrapper');
  });
}

function updateSearchExtraHeight() {
  const height = tableTitleRef.value?.offsetHeight || 0;
  if (!tableTitleBaseHeight.value) {
    tableTitleBaseHeight.value = height;
  }
  searchExtraHeight.value = Math.max(0, height - tableTitleBaseHeight.value);
  nextTick(() => {
    tableRef.value?.doLayout?.();
  });
}

function initTableTitleResize() {
  updateSearchExtraHeight();
  if (!tableTitleRef.value || typeof ResizeObserver === 'undefined') return;
  tableTitleResizeObserver = new ResizeObserver(updateSearchExtraHeight);
  tableTitleResizeObserver.observe(tableTitleRef.value);
}

const uniqueByRowKey = (list) => {
  const rowMap = new Map();
  list.forEach((item) => {
    const key = item?.[props.rowKey];
    if (key !== undefined && key !== null && !rowMap.has(key)) {
      rowMap.set(key, item);
    }
  });
  return [...rowMap.values()];
};

let isUpdatingSelection = false;
function handleSelectionChange(e) {
  if (dataStatus.value && !isUpdatingSelection) {
    if (props.single) {
      const lastRow = e[e.length - 1];
      isUpdatingSelection = true;
      tableRef.value?.clearSelection();
      if (lastRow) {
        tableRef.value?.toggleRowSelection(lastRow, true);
        selectAll.value = [lastRow];
      } else {
        selectAll.value = [];
      }
      nextTick(() => {
        isUpdatingSelection = false;
      });
    } else {
      dataKeyIdArr.value = props.data?.map((v) => {
        return v[`${props.rowKey}`];
      });
      const arr = selectAll.value.filter((v) => {
        return !dataKeyIdArr.value.includes(v[`${props.rowKey}`]);
      });

      selectAll.value = uniqueByRowKey([...arr, ...e]);
    }
  }
}
// 清空表格选中
function CancelSelect() {
  dataStatus.value = false;
  selectAll.value = [];
  tableRef.value.clearSelection();
  dataStatus.value = true;
}

function wrapperFn() {
  dongjieBtnShow.value = false;
}
// 冻结
function selectFn() {
  const list = [...allColumns.value]; // 复制数组，避免直接修改原数组（可选，根据需求决定）
  let fNumL = freezeNumL.value;
  let fNumR = freezeNumR.value;
  list.forEach((v) => {
    if (v.hiddenByDefault != true && fNumL > 0) {
      fNumL = fNumL - 1;
      v.fixed = 'left';
    } else {
      v.fixed = false;
    }
  });
  const reversedArr = [...list].reverse();

  reversedArr.forEach((v) => {
    if (v.hiddenByDefault != true && fNumR > 0) {
      fNumR = fNumR - 1;
      v.fixed = 'right';
    } else if (!v.fixed) {
      v.fixed = false;
    }
  });

  allColumns.value = [...reversedArr].reverse();
}
// 重置表格
function update() {
  // 更新
  updateVisibleColumns();
  tableScrollContainerFn();
  tableBodyWrapper();
}
// 初始化列配置
function initColumns() {
  // 获取本地缓存

  accompLishFn();
  updateVisibleColumns();
}

// 更新可见列
function updateVisibleColumns() {
  selectFn();
  // 显示隐藏
  visibleColumns.value = allColumns.value.filter((column) => !column.hiddenByDefault);
  tableKey.value++;
  // 本地缓存
  delAccompLish();
}

// 判断是否存在
function accompLishFn() {
  accompLish.value = localStorage.getItem('accompLish') ? JSON.parse(localStorage.getItem('accompLish')) : [];
  const targetItem = accompLish.value.find((item) => item.key === props.isKey);
  if (targetItem) {
    // 缓存存在
    const list = JSON.parse(JSON.stringify(props.columns));
    allColumns.value = syncArraysByProp(targetItem.allColumns, list);
    freezeNumL.value = targetItem.freezeNumL;
    freezeNumR.value = targetItem.freezeNumR;
  } else {
    allColumns.value = JSON.parse(JSON.stringify(props.columns));
    if (allColumns.value.some((column) => column.prop === 'action')) {
      freezeNumR.value = 1;
    }
  }
  // 基础宽度与补满宽度分离，不修改父页面 columns，也不缓存容器产生的额外空间。
  allColumns.value.forEach((column) => {
    if (column.prop === 'action' && column.resizable && aWidth.value) {
      column.width = aWidth.value;
    }
    column.width = getColumnBaseWidth(column);
  });
}
// 初始化数据处理
function syncArraysByProp(arr1, arr2) {
  // 提取数组2中所有prop值，用于快速查找
  const arr2Props = new Set(arr2.map((item) => item.prop));
  const cachedProps = new Set();
  // 按缓存顺序保留有效列，并清理历史缓存中的重复列。
  const filtered = arr1.filter((item) => {
    if (!arr2Props.has(item.prop) || cachedProps.has(item.prop)) return false;
    cachedProps.add(item.prop);
    return true;
  });
  // 提取过滤后数组的prop值
  const filteredProps = new Set(filtered.map((item) => item.prop));
  // 添加缓存中不存在的新列，entries 的第二项才是列配置。
  const toAdd = Array.from(arr2.entries()).filter(([, item]) => !filteredProps.has(item.prop));
  toAdd.forEach((v) => {
    filtered.splice(v[0], 0, v[1]);
  });
  filtered.forEach((v) => {
    arr2.forEach((s) => {
      if (v.prop == s.prop) {
        v.label = s.label;
        v.slot = s.slot;
        v.resizable = s.resizable;
        v.sortable = s.sortable;
        v.align = s.align;
        v.tooltip = s.tooltip;
        v.minWidth = s.minWidth;
      }
    });
  });
  // 合并结果
  return filtered;
}
// 本地缓存
function delAccompLish() {
  if (props.isKey) {
    accompLish.value = accompLish.value.filter((item) => item.key !== props.isKey);
    accompLish.value.push({
      key: props.isKey,
      freezeNumL: freezeNumL.value,
      freezeNumR: freezeNumR.value,
      allColumns: allColumns.value,
    });
    localStorage.setItem('accompLish', JSON.stringify(accompLish.value));
  }
}
// 设置宽度
function handleHeaderDragend(newWidth, oldWidth, column) {
  const target = allColumns.value.find((item) => item.prop === column.property);
  if (!target) return;
  target.width = Math.max(MIN_COLUMN_WIDTH, newWidth);
  // Element Plus 拖动会直接改内部 width；即使派生值未变，也要纠正最小宽度和单列补满。
  const index = visibleColumns.value.indexOf(target);
  column.width = displayColumnWidths.value[index];
  column.realWidth = column.width;
  delAccompLish();
  refreshTable();
  nextTick(() => {
    tableBodyWrapper();
  });
}

// 处理排序变化
function handleSortChange({ prop, order }) {
  refreshTable();
  if (!syncingSort) {
    emits('sort-change', { prop, order });
  }
}

function handleExpandChange(row, expandedRows) {
  emits('expandChange', row, expandedRows);
}
// 处理每页条数变化
function handleSizeChange(newSize) {
  emits('onpages', {
    page: props.currentPage,
    size: newSize,
  });
}
// 处理页码变化
function handleCurrentChange(newPage) {
  emits('onpages', {
    page: newPage,
    size: props.pageSize,
  });
}
// 刷新表格
function refreshTable() {
  nextTick(() => {
    // 通过ref获取表格实例（需在模板中给表格绑定ref="tableRef"）
    tableRef.value?.doLayout?.();
    tableScrollContainerFn();
    tableBodyWrapper();
  });
}

// 4. 监听父组件通过 eventBus 发送的滚动事件
const handleParentScroll = (scrollTop) => {
  if (props.clientHeight - 50 > scrollTop) {
    cHeight.value = props.clientHeight - scrollTop;
  } else {
    // tableRef.value.scrollTo({ top: scrollTop })
  }
};
</script>
<style lang="scss">
.pageCenterHeigth {
}

.advanced-table-popover {
  min-width: 480px !important;
}

.depopover {
  min-width: auto;
  /* 取消最小宽度限制 */
  max-width: none;
  /* 取消最大宽度限制 */
  width: fit-content;
  /* 宽度自适应内容（关键） */
  white-space: nowrap;
}
.auto-popover {
  min-width: 80px !important; /* 最小宽度 */
  width: max-content !important; /* 最大自适应 */
  max-width: 250px !important; /* 可选：限制最大宽度，防止太宽 */
  text-align: center;
  .el-button {
    text-align: center;
    display: block;
    width: 100%;
    margin: 0 0 10px 0;
  }
}
</style>

<style scoped lang="scss">
.advanced-table-container--sort-button-cycle {
  :deep(.el-table__header .caret-wrapper) {
    border-radius: var(--el-border-radius-small);
    transition: background-color var(--el-transition-duration-fast);

    &:hover,
    &:focus-visible {
      background-color: var(--el-fill-color);
    }

    // 上下箭头作为同一个原生按钮命中，沿用 Enter / Space 与原生排序事件。
    .sort-caret {
      pointer-events: none;
    }
  }
}

.advanced-table-container--summary-scrollbar-below {
  --advanced-table-summary-scrollbar-slot: 12px;

  :deep(.el-table.has-footer.el-table--scrollable-x) {
    .el-table__body-wrapper,
    .el-table__body-wrapper > .el-scrollbar {
      // 数据仍由内部 scrollbar__wrap 裁剪，仅允许原横条跨出明细区。
      overflow: visible;
    }

    .el-table__footer-wrapper {
      padding-bottom: var(--advanced-table-summary-scrollbar-slot);
    }

    .el-scrollbar__bar.is-horizontal {
      transform: translateY(calc(var(--advanced-table-summary-height) + var(--advanced-table-summary-scrollbar-slot)));
    }
  }
}

:deep(.el-table__expand-column) {
  position: relative;
}
:deep(.el-table .cell) {
  display: flex;
  min-width: 0;
}

:deep(.el-table__body .el-table__cell > .cell) {
  // 溢出提示的内联宽度未扣除 td 内边距，需限制在单元格内容区内。
  max-width: 100%;
}

:deep(.el-table__header .cell) {
  align-items: center;
}

:deep(.el-table .is-right .cell) {
  justify-content: flex-end;
}

:deep(.el-table .is-center .cell) {
  justify-content: center;
}

.advanced-table-header__info {
  flex: none;
  margin-inline-start: 5px;
  color: var(--el-text-color-secondary);
  cursor: help;
  font-size: 14px;
}

:deep(.advanced-table-cell-text) {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:deep(.el-table__expand-column .cell) {
  justify-content: center;
  align-items: center;
  overflow: visible;
}

/* 收起 → 加号 */
:deep(.el-table__expand-icon) {
  width: 22px !important;
  height: 22px !important;
  min-width: 22px;
  display: flex !important;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: transparent !important;
  background-image: url('../../assets/images/push.png');
  background-size: 18px 18px;
  background-repeat: no-repeat;
  background-position: center;
  overflow: visible;
}
:deep(.el-table__expand-icon .el-icon) {
  display: none;
}
:deep(.el-table__expand-icon--expanded) {
  background-image: url('../../assets/images/del.png');
  transform: none !important;
}
.selection_box {
  width: 100%;
  height: 50px;
  background: var(--bg-1);
  border: 1px solid var(--color-1);
  border-radius: 8px;
  margin-bottom: 10px;
  justify-content: space-between;
  padding: 8px 20px;
  .title {
    line-height: 34px;
  }

  .btn {
    line-height: 30px;
    font-size: 14px;
    .elescBtnT {
      margin: 0 20px;
      color: var(--color-1);
    }
  }
}
.actionResizable_icon {
  margin-inline-start: 10px;
  position: relative;
  font-size: 14px;
  top: 3px;
}
:deep(.el-popover) {
  width: auto !important;
}

.Issearch {
  flex: 1;
  // position: sticky;
}
.fill_tabs{
position: absolute;
bottom: 0;
left: 0;

}

/* 移除固定列数据单元格的边框 */
:deep(.el-table__row td) {
  border-inline-end: none !important;
  height: 46px;
  line-height: 46px;
  padding: 0 8px;
  font-size: 14px;
}

:deep(.el-table--border) {
  border: none !important;
}

:deep(.el-table__header th) {
  // border-inline-end: none !important;
  padding: 0 8px;
  height: 50px !important;

  color: #333;
  font-weight: 600;
  // 保留表格 border 属性以启用原生列宽拖拽，仅隐藏常驻分隔线。
  border-inline-end: none !important;
  background: #f2f3f5 !important;

  &:hover {
    background: #eeeeee !important;
    // border-inline-end: 1px solid #dfe6ec !important;
  }
}

// 点状手柄仅作提示，鼠标事件仍由 Element Plus 的列边缘拖拽处理。
.advanced-table-container :deep(.el-table__header th.advanced-table-header--resizable) {
  &::after {
    content: '';
    position: absolute;
    inset-inline-end: 1px;
    top: 50%;
    width: 8px;
    height: 16px;
    transform: translateY(-50%);
    color: var(--el-text-color-secondary);
    background-image: radial-gradient(circle, currentColor 1px, transparent 1px);
    background-size: 4px 4px;
    opacity: 0;
    pointer-events: none;
  }

  &:hover::after {
    opacity: 1;
  }
}

.table_title {
  margin-bottom: 10px;
  position: relative;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.justify-between {
  justify-content: space-between;
}

.pagination {
  margin-top: 10px;
  position: absolute;
  // bottom: -45px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  background: #fff;
  position: sticky;
  bottom: -20px;
  z-index: 99;
}

.horizontal {
  position: sticky;
  bottom: 32px;
  z-index: 999;
}

.horizontalBottom {
  bottom: 0px;
}

.dongjieBtn {
  position: relative;
  top: -5px;

  .el-button--text {
    color: #333;
    padding: 0;

    :hover {
      color: #1fc069 !important;
    }

    :focus {
      color: #1fc069 !important;
    }
  }

  .Btnshow {
    color: #1fc069 !important;
  }
}

.caobtn {
  .el-button--mini {
    padding-inline-start: 7px !important;
    padding-inline-end: 7px !important;
  }
}

.freezeBox {
  padding: 10px;
}

.popover_L {
  margin: 0 10px;
  margin: 20px;
}

.wrapper {
  height: 488px;
  min-width: 466px;

  .button {
    margin-inline-start: 10px;
  }

  .serch {
    padding: 10px 15px;
    height: 60px;
    box-sizing: border-box;
    border-bottom: 1px solid #dfe6ec;
  }

  .center {
    font-family:
      Helvetica Neue,
      Helvetica,
      PingFang SC,
      Hiragino Sans GB,
      Microsoft YaHei,
      微软雅黑,
      Arial,
      sans-serif;
    display: flex;

    .cen_r,
    .cen_l {
      flex: 1;

      .titBox {
        display: flex;
        justify-content: space-between;
        line-height: 20px;
        color: var(--color, #333333);
        font-weight: 500;
        font-size: 14px;
        user-select: none;
        padding: 15px;
      }

      .fixed {
        flex: 1;
      }

      .list {
        height: 370px;
        overflow-y: auto;
        padding: 0 15px;

        &::-webkit-scrollbar {
          width: 4px;
          /* 垂直滚动条宽度 */
          height: 4px;
          /* 水平滚动条高度 */
        }

        &::-webkit-scrollbar-thumb {
          background: #c2c2c2;
          /* 红色滑块 */
        }

        &::-webkit-scrollbar-thumb:hover {
          background: #c2c2c2;
          /* 深红色悬停 */
        }
      }
    }

    .cen_l {
      border-inline-end: 1px solid #dfe6ec;
      height: 440px;
    }
  }

  .titBox {
  }
}

.advanced-table-container {
  &.advanced-table-container--auto-height {
    height: auto;
  }
  position: relative;
  height: 100%;
  border-radius: 4px;
  width: 100%;

  // /* 处理固定列表头的边框 */
  // .el-table__fixed-header-wrapper .el-table__header th:not(.is-hidden) {
  //     border-inline-end: 1px solid #ebeef5 !important;
  //     background: red !important;
  // }

  // /* 移除固定列数据单元格的边框 */
  // .el-table__fixed td:not(.is-hidden) {
  //     border-inline-end: none !important;
  // }
}
</style>
